import $ from 'jquery'

$(document).ready(function() {
	$('.menu-toggle').click(function() {
		$(this)
			.toggleClass('is-active')
			.attr('aria-expanded', $(this).hasClass('is-active'))
		$('.site-header__right').toggleClass('is-active')
	})

	$('#header-search-icon').on('click', function(e) {
		if ($(window).width() > 1023) {
			e.preventDefault()
			$('#headerSearchForm').toggleClass('is-active')
		}
	})
	$('.site-header').removeClass('ready')
})
